import React from 'react';
import { css } from 'emotion';
import { Text } from '@weave/design-system';
import { theme } from '@weave/theme';
import { SyncCommandControlQueries } from 'apis/sync-engine-sources/queries';

export const SyncEngineStatusInfo = ({
  sourceId,
  engineId,
  name,
}: {
  sourceId: string;
  engineId: string;
  name?: string;
}) => {
  const { data, isLoading, error } =
    SyncCommandControlQueries.useGetStatusSyncCommandControl(sourceId, engineId);

  return (
    <div className={statusWrapper}>
      <Text as="span" size="medium" className={statusName}>
        {name}
      </Text>
      <div className={statusDivider} />
      <div className={statusDetails}>
        <Text as="span" size="small" color="light">
          Status :
        </Text>
        <Text as="span" size="small" className={statusValue(data?.status)}>
          {isLoading ? '...' : error ? 'N/A' : data?.status || 'N/A'}
        </Text>
        {name !== 'Container' && (
          <>
            <Text as="span" size="small" color="light">
              Engine ID
            </Text>
            <Text as="span" size="small" className={statusValue(data?.status)}>
              {isLoading ? '...' : engineId || 'N/A'}
            </Text>
          </>
        )}
        <Text as="span" size="small" color="light">
          Version
        </Text>
        <Text as="span" size="small" className={versionValue}>
          {isLoading ? '...' : error ? 'N/A' : data?.version || 'N/A'}
        </Text>
      </div>
    </div>
  );
};

const statusWrapper = css`
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  background: ${theme.colors.primary10};
  padding: ${theme.spacing(1, 2)};
  border-radius: ${theme.borderRadius.medium};
  border: 1px solid ${theme.colors.primary20};
  margin-top: ${theme.spacing(0.5)};
`;

const statusName = css`
  min-width: 140px;
  color: ${theme.colors.neutral80};
  font-weight: 600;
`;

const statusDivider = css`
  width: 1px;
  height: 20px;
  background-color: ${theme.colors.primary30};
  margin: 0 ${theme.spacing(2)};
`;

const statusDetails = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
`;

const statusValue = (status?: string) => css`
  color: ${status?.toUpperCase() === 'UP' || status?.toUpperCase() === 'RUNNING'
    ? theme.colors.success50
    : theme.colors.neutral80};
  background-color: ${theme.colors.white};
  padding: ${theme.spacing(0.25, 1)};
  border-radius: ${theme.borderRadius.small};
  border: 1px solid ${theme.colors.neutral20};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  font-weight: 600;
`;

const versionValue = css`
  color: ${theme.colors.primary60};
  background-color: ${theme.colors.white};
  padding: ${theme.spacing(0.25, 1)};
  border-radius: ${theme.borderRadius.small};
  border: 1px solid ${theme.colors.neutral20};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  font-weight: 600;
`;
